import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { routeConfigs } from 'src/app/common/constants/route.config';
import { ItineraryComponent } from './components/itinerary/itinerary.component';
import { TripPlannerComponent } from './components/trip.planner/trip.planner/trip.planner.component';

const routes: Routes = [
  {
    path: routeConfigs.tripPlanner.itinerary.path,
    component: ItineraryComponent,
    children: [
      {
        path: routeConfigs.tripPlanner.itinerary.editMode.path,
        component: ItineraryComponent,
      },
    ],
  },
  {
    path: routeConfigs.tripPlanner.tripPlanner.path,
    component: TripPlannerComponent,
    children: [],
  },
  {
    path: routeConfigs.tripPlanner.tour.path,
    component: ItineraryComponent,
  },
  {
    path: routeConfigs.tripPlanner.singleTour.path,
    component: ItineraryComponent,
  },
  {
    path: routeConfigs.tripPlanner.trips.path,
    component: TripPlannerComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TripPlannerRoutingModule {}
